import { BookOpenIcon, CalendarCheckIcon, LifeBuoyIcon, NewspaperIcon } from 'lucide-react';

export const supportNavigation = [
  {
    title: 'Book a demo',
    icon: CalendarCheckIcon,
    url: 'https://demo.tinct.ai',
    target: '_tab',
  },
  {
    title: 'Documentation',
    icon: BookOpenIcon,
    url: 'https://help.tinct.ai',
    target: '_tab',
  },
  {
    title: "What's new",
    icon: NewspaperIcon,
    url: 'https://feedback.tinct.ai/changelog',
    target: '_tab',
  },
  {
    title: 'Message support',
    icon: LifeBuoyIcon,
    url: 'mailto:support@tinct.ai',
    target: '_tab',
  },
];
